import React, { useEffect } from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ExternalLink, Palette, Loader2 } from 'lucide-react';

const CanvaRedirect = () => {
  useEffect(() => {
    // Abrir Canva automaticamente em nova aba
    window.open('https://www.canva.com/', '_blank');
  }, []);

  return (
    <div className="p-6 flex items-center justify-center min-h-[60vh]">
      <Card className="max-w-md w-full">
        <CardContent className="p-8 text-center space-y-4">
          <div className="w-16 h-16 mx-auto bg-gradient-to-br from-purple-500 to-pink-500 rounded-2xl flex items-center justify-center">
            <Palette className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-xl font-bold">Canva</h2>
          <p className="text-muted-foreground">
            O Canva foi aberto em uma nova aba. Se não abriu automaticamente, clique no botão abaixo.
          </p>
          <Button 
            onClick={() => window.open('https://www.canva.com/', '_blank')}
            className="w-full bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600"
          >
            <ExternalLink className="w-4 h-4 mr-2" />
            Abrir Canva
          </Button>
          <p className="text-xs text-muted-foreground">
            Crie designs profissionais para suas campanhas de marketing
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default CanvaRedirect;
